import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
  Grid,
  TextField,
} from '@material-ui/core'

import { ButtonAction, LoadingBox, Select, Label } from 'components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'

const ConfirmationRiskDialog = ({
  open,
  setOpen,
  handleConfirm,
  dataProcessId,
  setAdoptedFragilityId,
  setDefaultFragilityId,
}) => {
  const { response, isLoading } = useFetch(
    service.dponet.dataProcesses.suggestedMatrixRisk,
    { dataProcessId },
    [],
  )

  const { response: responseOptions, isLoading: isLoadingRisk } = useFetch(
    service.dponet.matrixRisk.list,
    { minimal: true },
    [],
  )

  const options = isLoadingRisk ? [] : responseOptions?.data?.matrixRisks || []

  const fragilityId =
    !isLoading && response?.data?.matrixRisk?.id
      ? String(response?.data?.matrixRisk?.id)
      : ''

  useEffect(() => {
    if (fragilityId) return setDefaultFragilityId(fragilityId)
    //eslint-disable-next-line
  }, [fragilityId])

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">Análise de Risco</Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <Box mt={1} mb={1}>
        <DialogContent>
          {isEmpty(fragilityId) ? (
            <>
              <Typography variant="body2">
                Calculando o risco do processo
              </Typography>
              <LoadingBox minHeight={0} />
            </>
          ) : (
            <>
              <Typography variant="body1">
                O Risco sugerido é calculado e recomendado pela plataforma. Se
                desejar, você pode alterar o risco adotado nesse processo
              </Typography>
              <Box my={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Label title="Risco sugerido">
                      <TextField
                        disabled
                        value={
                          response?.data?.matrixRisk?.name ||
                          'Risco não encontrado'
                        }
                      />
                    </Label>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Label title="Risco adotado">
                      <Select
                        items={options}
                        defaultValue={fragilityId}
                        onChange={(event) =>
                          setAdoptedFragilityId(event.target.value)
                        }
                      />
                    </Label>
                  </Grid>
                </Grid>
              </Box>
              <Typography variant="body1">
                Após a confirmação, o processo será enviado para análise
                jurídica, e terá seu status alterado para "Aguardando revisão".
              </Typography>
            </>
          )}
        </DialogContent>
      </Box>
      <Divider />
      <DialogActions p={2}>
        <Box pl={2} pr={1}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Voltar
          </Button>
        </Box>
        <ButtonAction
          variant="contained"
          type="submit"
          color="primary"
          action={handleConfirm}
          name="Confirmar"
        />
      </DialogActions>
    </Dialog>
  )
}

ConfirmationRiskDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  handleConfirm: PropTypes.func,
  dataProcessId: PropTypes.number,
}

ConfirmationRiskDialog.defaultProps = {
  open: false,
  setOpen: () => {},
  handleConfirm: () => {},
}

export default ConfirmationRiskDialog
